import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as style from './RentFastNSave.css';
import clsx from 'clsx';
import { clickOpenModal } from '../tracking';
import { useSelector } from 'react-redux';
import { selectUser } from 'shared/selectors/user';

interface IRentFastNSaveProps {
  onChangeModalVisible: VoidFunction;
}

export const RentFastNSave: React.FC<IRentFastNSaveProps> = ({ onChangeModalVisible }) => {
  const device = useDeviceType();

  const user = useSelector(selectUser);

  const userId = user?.isAuthenticated && user.userId ? user.userId : undefined;

  const handleOpenModal = () => {
    onChangeModalVisible();
    clickOpenModal('submitApplication', userId);
  };

  return (
    <div
      className={clsx(
        style['container'],
        device === 'tablet' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['text-block']}>
        <h1 className={style['title']}>Сдайте квартиру быстро и безопасно</h1>
        <div className={style['subtitle']}>Для пользователей Циан это бесплатно</div>
      </div>
      <div className={style['btn-container']}>
        <LinkButton size="L" fullWidth onClick={handleOpenModal}>
          Оставить заявку
        </LinkButton>
      </div>
    </div>
  );
};
